class ProductImageSlider {
  constructor(element) {
    this.container = element
    this.slider = element.querySelector('.product-image__slides')
    this.slides = element.querySelectorAll('.image-wrapper')
    this.prevButton = element.querySelector('.product-image__arrow--prev')
    this.nextButton = element.querySelector('.product-image__arrow--next')

    if (!this.slider || !this.prevButton || !this.nextButton) return

    this.currentIndex = 0
    this._guardActive = false
    this._guardFn = null
    this._guardTimeout = null

    this.init()
  }

  init() {
    this.enable()

    // When leaving, remove slider-ready so bfcache stores the hidden state.
    // On restore, browser sets scrollLeft before pageshow fires — our enable()
    // overrides it before anything is visible.
    window.addEventListener('pagehide', () => {
      this.slider.classList.remove('slider-ready')
    })

    window.addEventListener('pageshow', (e) => {
      if (e.persisted) this.enable()
    })

    // Check if slider is needed
    this.checkSliderNeed()

    // Add event listeners for buttons
    this.prevButton.addEventListener('click', () => this.slide('prev'))
    this.nextButton.addEventListener('click', () => this.slide('next'))

    // Add scroll listener to update arrows
    this.slider.addEventListener('scroll', () => this.updateArrows())

    // Update arrows on resize
    window.addEventListener('resize', () => {
      this.checkSliderNeed()
      this.updateArrows()
    })
  }

  enable() {
    // Clean up any previous guard before re-enabling (e.g., on pageshow)
    this._releaseGuard()

    // Instant reset — no smooth animation during initialization
    this.slider.style.scrollBehavior = 'auto'
    this.slider.scrollLeft = 0
    this.slider.classList.add('slider-ready')
    this.slider.style.scrollBehavior = ''

    this.updateArrows()

    // Guard against automated scroll calls (e.g., scrollIntoView from URL hashes)
    // that fire after the slider is enabled. Release on user touch or after 2s.
    this._guardActive = true

    this._guardFn = () => {
      if (!this._guardActive) return
      this.slider.style.scrollBehavior = 'auto'
      this.slider.scrollLeft = 0
      this.slider.style.scrollBehavior = ''
    }

    this.slider.addEventListener('scroll', this._guardFn)
    this.slider.addEventListener('touchstart', () => this._releaseGuard(), {
      once: true,
      passive: true,
    })

    this._guardTimeout = setTimeout(() => this._releaseGuard(), 2000)
  }

  _releaseGuard() {
    this._guardActive = false
    if (this._guardFn) {
      this.slider.removeEventListener('scroll', this._guardFn)
      this._guardFn = null
    }
    if (this._guardTimeout) {
      clearTimeout(this._guardTimeout)
      this._guardTimeout = null
    }
  }

  checkSliderNeed() {
    const slideCount = this.slides.length
    const isMobile = window.innerWidth < 1024

    if (slideCount > 1 && isMobile) {
      this.prevButton.style.display = 'flex'
      this.nextButton.style.display = 'flex'
      this.prevButton.disabled = true
      this.nextButton.disabled = false
    } else {
      this.prevButton.style.display = 'none'
      this.nextButton.style.display = 'none'
    }
  }

  slide(direction) {
    // User is navigating — release the scroll guard immediately
    this._releaseGuard()

    const slideWidth = this.slider.offsetWidth
    const currentScroll = this.slider.scrollLeft

    if (direction === 'prev') {
      this.slider.scrollLeft = currentScroll - slideWidth
    } else {
      this.slider.scrollLeft = currentScroll + slideWidth
    }
  }

  updateArrows() {
    if (!this.slider) return

    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth
    const currentScroll = this.slider.scrollLeft

    if (maxScroll <= 0) {
      this.prevButton.disabled = true
      this.nextButton.disabled = false
      return
    }

    this.prevButton.disabled = currentScroll <= 0
    this.nextButton.disabled = currentScroll >= maxScroll - 1
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const productGallery = document.querySelector('[data-product-gallery]')
  if (productGallery) {
    new ProductImageSlider(productGallery)
  }
})

// Reinitialize on Shopify section load (theme editor)
document.addEventListener('shopify:section:load', () => {
  const productGallery = document.querySelector('[data-product-gallery]')
  if (productGallery) {
    new ProductImageSlider(productGallery)
  }
})
